<template>
    <div>
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
          <b-row>
              <b-col cols="12">
                 <b-card>
                    <div slot="header" class="mb-0">
                        <!-- <h3 v-if="direction == 'IN'">{{language_terms['STOCK_IN']}}</h3>
                        <h3 v-if="direction == 'OUT'">{{language_terms['STOCK_OUT']}}</h3> -->
                        <h3>Stock Adjustment</h3>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <form-wizard @on-complete="onComplete" title="" subtitle="" color="#5e72e4" :finishButtonText="language_terms['SUBMIT']"   >
                                <tab-content :title="language_terms['WAREHOUSE_AND_MOVEMENT_SELECTION']" :before-change="beforeStepChangeFirstTab">
                                    <b-row>
                                        <b-col cols="4">
                                            <base-input :label="language_terms['TYPE']">
                                                <el-select v-model="stockcard.type" filterable :placeholder="language_terms['TYPE']" @change="onChangeType">
                                                    <el-option
                                                        v-for="option in types"
                                                        :key="option.code"
                                                        :label="language_terms[option.name]"
                                                        :value ="option.code">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="4">
                                            <base-input :label="language_terms['WAREHOUSE']">
                                                <el-select v-model="stockcard.warehouse_id" filterable :placeholder="language_terms['WAREHOUSE']">
                                                    <el-option
                                                        v-for="option in warehouses"
                                                        :key="option.id"
                                                        :label="option.name"
                                                        :value ="option.id">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="4">
                                            <base-input :label="language_terms['MOVEMENT_DATE']" >
                                                <flat-picker
                                                    slot-scope="{ focus, blur }"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    style="background-color: white"
                                                    class="form-control datepicker"
                                                    v-model="stockcard.movement_date">
                                                </flat-picker>
                                            </base-input>
                                        </b-col>
                                        <b-col :cols="(stockcard.type == 'GRN_PO') ? 6 : 12" v-if="stockcard.type == 'GRN' || stockcard.type == 'GRN_PO'">
                                            <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                                            <multiselect
                                                    :internalSearch = "false"
                                                    v-model="stockcard.vendor"
                                                    id="ajax"
                                                    label="name"
                                                    track-by="id"
                                                    placeholder="Type to search"
                                                    open-direction="bottom"
                                                    :options="vendors"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :options-limit="300"
                                                    :limit="50"
                                                    :max-height="600"
                                                    :show-no-results="false"
                                                    :hide-selected="false"
                                                    @search-change="asyncFindVendor"
                                                    @input="onSelectVendor"
                                            >
                                            </multiselect>
                                        </b-col>
                                        <b-col cols="6" v-if="stockcard.type == 'GRN_PO' && stockcard.contact_id">
                                            <base-input :label="language_terms['PURCHASE_ORDERS']" >
                                                <el-select v-model="stockcard.reference_id" filterable :placeholder="language_terms['PURCHASE_ORDERS']" >
                                                    <el-option
                                                        v-for="option in pos"
                                                        :key="option.document_id"
                                                        :label="option.code"
                                                        :value ="option.document_id">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>
                                        <b-col :cols="(stockcard.type == 'DO_SO') ? 6 : 12" v-if="stockcard.type == 'DO' || stockcard.type == 'DO_SO'">
                                            <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                                            <multiselect
                                                    :internalSearch = "false"
                                                    v-model="stockcard.customer"
                                                    id="ajax"
                                                    label="name"
                                                    track-by="id"
                                                    placeholder="Type to search"
                                                    open-direction="bottom"
                                                    :options="customers"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :options-limit="300"
                                                    :limit="50"
                                                    :max-height="600"
                                                    :show-no-results="false"
                                                    :hide-selected="false"
                                                    @search-change="asyncFindCustomer"
                                                    @input="onSelectCustomer"
                                            >
                                            </multiselect>
                                        </b-col>
                                        <b-col cols="6" v-if="stockcard.type == 'DO_SO' && stockcard.contact_id">
                                            <base-input :label="language_terms['SALES_ORDERS']" >
                                                <el-select v-model="stockcard.reference_id" filterable :placeholder="language_terms['SALES_ORDERS']" >
                                                    <el-option
                                                        v-for="option in sos"
                                                        :key="option.document_id"
                                                        :label="option.code"
                                                        :value ="option.document_id">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="12" class="mt-2">
                                            <base-input :label="language_terms['REMARKS']">
                                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="stockcard.remarks"></textarea>
                                            </base-input>
                                        </b-col>
                                    </b-row>
                                </tab-content>
                                <tab-content :title="language_terms['MOVEMENT_ITEMS']">
                                  <template v-if="stockcard.type == 'ADJUSTMENT' || stockcard.type == 'GRN'">
                                    <b-row>
                                        <b-col cols="4">
                                            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                            <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="stockcard.product_code"/>
                                        </b-col>
                                        <b-col cols="2" >
                                            <base-input :label="language_terms['LOCATIONS']" >
                                                <el-select v-model="stockcard.location" filterable :placeholder="language_terms['LOCATIONS']" 
                                                    @change="onSelectLocation" value-key="id" :disabled="display_location == '0' || !stockcard.product_id">
                                                    <el-option
                                                        v-for="option in locations"
                                                        :key="option.id"
                                                        :label="option.name"
                                                        :value ="option">
                                                    </el-option>
                                                </el-select>
                                            </base-input>
                                        </b-col>
                                        <b-col cols="1">
                                            <base-input v-model="stockcard.allocate_qty" type="number" :label="language_terms['QTY']" :min="0"></base-input>
                                        </b-col>
                                        <b-col cols="2" v-if="stockcard.available_qty != null && stockcard.available_qty != ''">
                                            <base-input v-model="stockcard.available_qty" type="number" :label="language_terms['AVAILABLE_QTY']" disabled></base-input>
                                        </b-col>
                           
                                        <b-col cols="1">
                                            <base-input v-model="stockcard.lot_reference" type="text" :label="language_terms['LOT_NUMBER']" :disabled="stockcard.has_lot == '0'"></base-input>
                                        </b-col>
                                        <b-col cols="2" >
                                            <base-input :label="language_terms['EXPIRY_DATE']" v-if="stockcard.expiry_mths">
                                                <flat-picker
                                                    slot-scope="{ focus, blur }"
                                                    @on-open="focus"
                                                    @on-close="blur"
                                                    style="background-color: white"
                                                    class="form-control datepicker"
                                                    v-model="stockcard.expiry_date">
                                                </flat-picker>
                                            </base-input>     
                                            <base-input type="date" :label="language_terms['EXPIRY_DATE']"  v-model="stockcard.expiry_date" v-else disabled/>                               
                                        </b-col>
                                        <b-col lg="11" v-if="(stockcard.type == 'GRN' && stockcard.is_trade == '1')">
                                            <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                            <multiselect
                                                    v-model="stockcard.trade_item"
                                                    label="product_name"
                                                    track-by="product_name"
                                                    placeholder="Type to search"
                                                    open-direction="bottom"
                                                    :options="tradeitem_desp_list"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :options-limit="300"
                                                    :limit="50"
                                                    :max-height="600"
                                                    :show-no-results="false"
                                                    :hide-selected="true"
                                                    @search-change="asyncFindTradeItemDesp($event)"
                                                    :internalSearch = "false"
                                                    :taggable="true"
                                                    @tag="addTag($event)"
                                                    @select="onSelectTradeItemDesp($event)"
                                                >
                                            </multiselect>
                                        </b-col>
                                        <b-col lg="11" v-if="(stockcard.type == 'ADJUSTMENT' && stockcard.is_trade == '1')">
                                            <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                            <multiselect
                                            :internalSearch = "false"
                                            v-model="stockcard.trade_item"
                                            id="ajax"
                                            label="product_name"
                                            track-by="product_code"
                                            placeholder="Type to search"
                                            open-direction="bottom"
                                            :options="tradeitem_desp_list"
                                            :multiple="false"
                                            :searchable="true"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :options-limit="300"
                                            :limit="50"
                                            :max-height="600"
                                            :show-no-results="false"
                                            :hide-selected="false"
                                            @search-change="asyncFindTradeItemDespForAdjustment"
                                            @input="onSelectTradeItemDesp"
                                            >
                                            </multiselect>
                                        </b-col>
                                        <b-col cols="1" class="mt-4">
                                            <base-button icon type="success" @click="clickOnAdd" class="mt-1">
                                                {{language_terms['ADD']}}
                                            </base-button>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-4" v-if="stockcard_items.length > 0">
                                        <b-col cols="12">
                                            <b-table-simple hover responsive>
                                                <b-thead head-variant="light">
                                                    <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                    <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                    <b-th>{{language_terms['QTY']}}</b-th>
                                                    <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                    <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                    <b-th>{{language_terms['LOCATION']}}</b-th>
                                                    <b-th>{{language_terms['REMARKS']}}</b-th>
                                                    <b-th></b-th>
                                                </b-thead>
                                                <b-tbody v-for="(item, index) in stockcard_items" :key="index">
                                                    <tr>
                                                        <td>{{item.product_code}}</td>
                                                        <td>{{item.product_name}}</td>
                                                        <td>{{item.allocate_qty}}</td>
                                                        <td>{{item.lot_reference ? item.lot_reference : '-'}}</td>
                                                        <td>{{item.expiry_date ? item.expiry_date : '-'}}</td>
                                                        <td>{{item.location_name}}</td>
                                                        <td>{{item.remarks}}</td>
                                                        <td>
                                                            <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                                                            <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" v-if="item.lots.length"><i class="fa fa-angle-down"></i></base-button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item.is_collapsed">
                                                        <td colspan="7">
                                                            <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                                <b-table-simple responsive>
                                                                <b-thead head-variant="light">
                                                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                                        <b-th>{{language_terms['LOT_QTY']}}</b-th>
                                                                        <b-th>{{language_terms['ALLOCATE_QTY']}}</b-th>
                                                                </b-thead>
                                                                <b-tbody v-for="(lot, j) in item.lots" :key="j">
                                                                    <td>{{lot.location_name}}</td>
                                                                    <td>{{lot.lot_reference}}</td>
                                                                    <td>{{lot.expiry_date}}</td>
                                                                    <td>{{lot.qty}}</td>
                                                                    <td>
                                                                        <input v-model="lot.allocate_qty" type="number" class="form-control"/>                                                                   
                                                                    </td>
                                                                </b-tbody>
                                                                </b-table-simple>
                                                            </b-collapse>
                                                        </td>
                                                    </tr>
                                                </b-tbody>
                                            </b-table-simple>
                                        </b-col>
                                    </b-row>
                                  </template>
                                  <template  v-if="stockcard.type == 'GRN_PO'">
                                      <b-row class="mt-4" v-if="stockcard_items.length > 0">
                                          <b-col cols="12">
                                              <b-table-simple hover responsive>
                                                  <b-thead head-variant="light">
                                                    <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                    <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                    <b-th>{{language_terms['PO_QTY']}}</b-th>
                                                    <b-th>{{language_terms['BALANCE']}}</b-th>
                                                    <b-th>{{language_terms['LOCATION']}}</b-th>
                                                    <b-th>{{language_terms['QTY']}}</b-th>
                                                    <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                    <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                    <b-th></b-th>
                                                  </b-thead>
                                                  <b-tbody v-for="(item, index) in stockcard_items" :key="index">
                                                      <tr>
                                                        <td>{{item.product_code}}</td>
                                                        <td>{{item.product_name}}</td>
                                                        <td>{{item.qty}}</td>
                                                        <td>{{item.balance_qty}}</td>
                                                        <td>
                                                            <el-select v-model="item.location" filterable :placeholder="language_terms['LOCATIONS']"  
                                                                value-key="id" @change="onSelectLocationForItem(index, item)">
                                                                <el-option
                                                                    v-for="option in item.locations"
                                                                    :key="option.id"
                                                                    :label="option.name"
                                                                    :value ="option">
                                                                </el-option>
                                                            </el-select>
                                                        </td>
                                                        <td><input v-model="item.allocate_qty" type="number" class="form-control"/></td>
                                                        <td><input v-model="item.lot_reference" type="number" class="form-control" :disabled="item.is_disabled == '1'"/></td>
                                                        <td>
                                                           <input v-model="item.expiry_date" type="date" class="form-control" :disabled="item.is_disabled == '1'"/>
                                                        </td>
                                                        <td>
                                                            <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                                                        </td>
                                                      </tr>
                                                 </b-tbody>
                                              </b-table-simple>
                                          </b-col>
                                      </b-row>
                                  </template>
                                  <template  v-if="stockcard.type == 'DO_SO' || stockcard.type == 'DO'">
                                    <b-row v-if="stockcard.type == 'DO'">
                                        <b-col cols="6">
                                            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                                            <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="stockcard.product_code"/>
                                        </b-col>
                                        <b-col cols="5">
                                            <!-- {{stockcard.allocate_qty}} -->
                                            <base-input v-model="stockcard.allocate_qty" type="number" :label="language_terms['QTY']"></base-input>
                                        </b-col>
                                        <!-- <b-col cols="3">
                                            <base-input v-model="stockcard.item_remarks" type="text" :label="language_terms['REMARKS']"></base-input>
                                        </b-col> -->
                                        <b-col lg="11" v-if="(stockcard.is_trade == '1')">
                                            <label class="form-control-label">{{language_terms["PRODUCT_NAME"]}}</label>
                                            <multiselect
                                                    v-model="stockcard.trade_item"
                                                    label="product_name"
                                                    track-by="product_name"
                                                    placeholder="Type to search"
                                                    open-direction="bottom"
                                                    :options="tradeitem_desp_list"
                                                    :multiple="false"
                                                    :searchable="true"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :options-limit="300"
                                                    :limit="50"
                                                    :max-height="600"
                                                    :show-no-results="false"
                                                    :hide-selected="true"
                                                    @search-change="asyncFindTradeItemDesp($event)"
                                                    :internalSearch = "false"
                                                    :taggable="true"
                                                    @tag="addTag($event)"
                                                    @select="onSelectTradeItemDesp($event)"
                                                >
                                            </multiselect>
                                        </b-col>
                                        <b-col cols="1" class="mt-4">
                                            <base-button icon type="success" @click="addToDoItems" class="mt-1">
                                                {{language_terms['ADD']}}
                                            </base-button>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-4" v-if="stockcard_items.length > 0">
                                        <b-col cols="12">
                                            <b-table-simple hover responsive>
                                                <b-thead head-variant="light">
                                                    <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                                    <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                                    <b-th>{{language_terms['SO_QTY']}}</b-th>
                                                    <b-th>{{language_terms['BALANCE']}}</b-th>
                                                    <b-th>{{language_terms['AVAILABLE_QTY']}}</b-th>
                                                    <b-th>{{language_terms['QTY']}}</b-th>
                                                    <b-th></b-th>
                                                </b-thead>
                                                <b-tbody v-for="(item, index) in stockcard_items" :key="index">
                                                    <tr>
                                                        <td>{{item.product_code}}</td>
                                                        <td>
                                                            {{item.product_name}}
                                                        </td>
                                                        <td>
                                                            {{item.qty}} 
                                                        </td>
                                                        <td>
                                                            {{item.balance_qty}} 
                                                        </td>
                                                        <td>
                                                            {{item.available_qty}}
                                                        </td>
                                                        <td>
                                                            <base-input v-model="item.allocate_qty" type="number" @change="onChangeAllocateQty(item, index)" :disabled="item.is_visible == '0'" v-if="stockcard.type == 'DO_SO'"></base-input>
                                                            <base-input v-model="item.allocate_qty" type="number" v-if="stockcard.type == 'DO'"></base-input>
                                                        </td>
                                                        <td>
                                                            <base-button  size="sm" icon type="danger" @click="deleteItem(index)" class="mr-4" :disabled="item.is_visible == '0'"><i class="fas fa-trash-alt"></i ></base-button>
                                                            <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" v-if="item.lots.length"><i class="fa fa-angle-down"></i></base-button>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="item.is_collapsed">
                                                        <td colspan="6">
                                                            <b-collapse v-model="item.is_collapsed" class="mt-2">
                                                                <b-table-simple responsive>
                                                                <b-thead head-variant="light">
                                                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                                                        <b-th>{{language_terms['LOT_QTY']}}</b-th>
                                                                        <b-th>{{language_terms['ALLOCATE_QTY']}}</b-th>
                                                                </b-thead>
                                                                <b-tbody v-for="(lot, j) in item.lots" :key="j">
                                                                    <td>{{lot.location_name}}</td>
                                                                    <td>{{lot.lot_reference}}</td>
                                                                    <td>{{lot.expiry_date}}</td>
                                                                    <td>{{lot.qty}}</td>
                                                                    <td>
                                                                        <input v-model="lot.allocate_qty" type="number" class="form-control" v-if="lot.is_disabled == '0'"/>     
                                                                        <span v-if="lot.is_disabled == '1'">{{lot.allocate_qty}}</span>                                                          
                                                                    </td>
                                                                </b-tbody>
                                                                </b-table-simple>
                                                            </b-collapse>
                                                        </td>
                                                    </tr>
                                                </b-tbody>
                                            </b-table-simple>
                                        </b-col>
                                    </b-row>
                                  </template>
                            </tab-content>
                            </form-wizard>
                        </b-col>
                    </b-row>

                 </b-card>
              </b-col>
          </b-row>
      </b-container>

    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from 'vuex';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import productLookup from "@/components/Autocomplete.vue";
import locationLookup from "@/components/Autocomplete.vue";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import BaseInput from '../../components/Inputs/BaseInput.vue';
import BaseRadio from '../../components/Inputs/BaseRadio.vue';

export default {
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        locationLookup,
        FormWizard,
        TabContent,
        BaseInput,
        BaseRadio
    },
    props: {
        direction: {
            type: String,
            default: "IN",
            description: "DIRECTION",
            required: true,
        },
        types: {
            type:Array,
            default: function () { return [] },
            description: "Types",
            required: true,
        },
    },
    data(){
        return{
            loading:false, 
            stockcard_items:[],
            tradeitem_desp_list:[],
            desp_tags:[],
            customers:[],
            locations:[],
            vendors:[],
            is_confirmed:0,
            //direction:'IN',
            display_location:"1",
            sos:[],
            pos:[],
            stockcard:{
                available_qty:"",
                contact_id:"",
                reference_id:null,
                type:"ADJUSTMENT",
                item_remarks:"",
                remarks:"",
                warehouse_id:"",
                location_id:"",
                location:{},
                movement_date:null,
                product_code:null,
                product_id:null,
                product_name:"",
                has_lot:"0",
                expiry_date:null,
                allocate_qty:null,
                is_trade:"0",
                expiry_mths:"",
                customer:{},
                vendor:{},
                trade_item:{}
            },
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        }
    },
      computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            warehouses:(state)=>state.locations.warehouses,
            is_stockcard_created:(state) => state.stockcards.is_stockcard_created,
            stockcard_filter:(state) => state.stockcards.filter,
            so_list:(state) => state.sales.so_list,
            po_list:(state) => state.purchase.po_list,
            so_items:(state) => state.sales.so_items,
            po_items:(state) => state.purchase.po_items,
            lots:(state) => state.stockcards.lots,
            is_confirmation_required:(state) => state.stockcards.is_confirmation_required,
            confirmation_messages:(state) => state.stockcards.confirmation_messages,
            allow_qty: (state) => state.sales.allow_qty
        })
    },
    async mounted(){
        await this.$store.dispatch("locations/fetchWarehouses", {});

        if(this.warehouses.length > 0)
        {
            if(!this.stockcard.warehouse_id)
            {
                this.stockcard.warehouse_id = this.warehouses[0].id
            }
        }

        if(!this.stockcard.movement_date)
        {
            this.stockcard.movement_date = moment().format("YYYY-MM-DD");
        }
    },
    methods: 
    {
        addTag(newTag)
        {
            if(newTag)
            {
                let obj = {product_name: newTag, contact_id:this.stockcard.contact_id, date:this.stockcard.movement_date}
                if(this.isFoundInList(newTag) == 0)
                {
                    this.desp_tags.push(obj)
                    Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
                    this.stockcard.trade_item = obj
                    this.stockcard.product_name = newTag
                }

            }
        },
        onSelectTradeItemDesp(selectedOption)
        {
            if(selectedOption)
            {
                this.stockcard.product_name = selectedOption.product_name
            }
        },
        async asyncFindTradeItemDespForAdjustment (query) {
            let product_id = this.stockcard.product_id
            let pv = { value: query, contact_id:this.stockcard.contact_id, date:this.stockcard.movement_date, product_id: product_id, is_adjustment:1};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        async asyncFindTradeItemDesp (query) 
        {
            let product_id = this.stockcard.product_id
            let pv = { value: query, contact_id:this.stockcard.contact_id, date:this.stockcard.movement_date, product_id: product_id};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
                Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        async onChangeAllocateQty(item, index)
        {

            if(item)
            {
                await this.$store.dispatch("sales/validateSoQtyForDo" , {document_item_id:item.id, allocate_qty:item.allocate_qty})
                item.allocate_qty = item.allocate_qty * 1
                if(item.allocate_qty > this.allow_qty)
                {
                    item.allocate_qty = this.allow_qty
                    this.$set(this.stockcard_items, index , item) 
                }
            }
            
        
        },
        onSelectLocationForItem(index, item)
        {
            let selectedOption = item.location
            if(selectedOption)
            {
                item.location_id = selectedOption.id
                item.location_code = selectedOption.code
                item.location_name = selectedOption.name
                this.$set(this.stockcard_items, index , item) 

            }
        },
        onSelectLocation(selectedOption)
        {
            if(selectedOption)
            {
                this.stockcard.location_id = selectedOption.id
                this.stockcard.location_code = selectedOption.code
                this.stockcard.location_name = selectedOption.name
                this.stockcard.available_qty = selectedOption.available_qty
            }
        },
        handleCollaspe(index, row)
        {
            if(row.is_collapsed)
            {
                row.is_collapsed = false
            }
            else
            {
                row.is_collapsed = true
            }

            this.$set(this.stockcard_items, index , row) 
        },
        async onSelectVendor(selectedOption)
        {
            if(selectedOption)
            {
                this.stockcard.contact_id = selectedOption.id

                if(this.stockcard.type == 'GRN_PO')
                {
                    await this.$store.dispatch("purchase/fetchPosForGRN" , {contact_id:selectedOption.id})

                    if(this.po_list)
                    {
                        this.pos = this.po_list
                    }
                }
            }
        },
        async onSelectCustomer(selectedOption)
        {
            if(selectedOption)
            {
                this.stockcard.contact_id = selectedOption.id

                if(this.stockcard.type == 'DO_SO')
                {
                    await this.$store.dispatch("sales/fetchSosForDo" , {contact_id:selectedOption.id})

                    if(this.so_list)
                    {
                        this.sos = this.so_list
                    }
                }
            }
        },
        async asyncFindLocation()
        {
            let pv = {warehouse_id: this.stockcard.warehouse_id, product_id:this.stockcard.product_id, direction:this.direction, movement_date:this.stockcard.movement_date};
            await axios.post(apiRoutes['LOOKUP_LOCATIONS_BY_WH'], pv, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.locations = response.data.data;
                } 
                else 
                {
                    this.locations = [];
                }
                this.isLoading = false;
            }).catch((error) => {
                
            if (error.response) {
                alert(error.response.data.msg)
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        async asyncFindVendor(query)
        {
            let pv = { value: query };
            await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        this.vendors = response.data.data;
                    } else {
                        this.vendors = [];
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.msg)
                    } else {
                        console.log("Problem submitting New Post", error);
                    }
            });
        },
        async asyncFindCustomer(query) 
        {
            let pv = { value: query };
            await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.customers = response.data.data;
                } else {
                    this.customers = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
            if (error.response) {
                alert(error.response.data.msg)
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        onChangeType()
        {
            console.log(this.stockcard.type)
            if(this.stockcard.type == 'DO')
            {

            }
        },
        async searchStockCard()
        {
            this.isLoading = true
            let filter = {
                            keyword:"",
                            date_from:null,
                            date_to:null,
                            direction:this.direction
                        }
            if(this.stockcard_filter)
            {
                filter = this.stockcard_filter
            }
            await this.$store.dispatch('stockcards/quickSearch', filter)

            this.isLoading = false
        },
        getWHDetails(id)
        {   
            let data = {}
            for(let i = 0; i < this.warehouses.length; i++)
            {
                console.log(this.warehouses[i])
                console.log(id)

                if(this.warehouses[i].id == id) {
                    data = this.warehouses[i]
                }
            }

            return data

        },
        async beforeStepChangeFirstTab()
        {
            let isValid = false
            if(this.stockcard.warehouse_id != null && this.stockcard.warehouse_id != ''  && this.stockcard.movement_date)
            {
                let wh = this.getWHDetails(this.stockcard.warehouse_id)
                if(wh)
                {
                    if(wh.children_count == 0)
                    {
                        this.display_location = "0"
                        this.stockcard.location_id = this.stockcard.warehouse_id
                        this.stockcard.location_code = wh.code
                        this.stockcard.location_name = wh.name
                    }
                }
                if(this.stockcard.type == 'ADJUSTMENT')
                {
                    isValid = true
                }
                else if(this.stockcard.type == 'DO_SO')
                {

                   if(this.stockcard.reference_id != '')
                   {
                       await this.$store.dispatch("sales/fetchSoItems", {document_id:this.stockcard.reference_id, warehouse_id:this.stockcard.warehouse_id, movement_date:this.stockcard.movement_date })
                       this.stockcard_items = this.so_items
                       isValid = true
                   }
                   else
                   {
                       alert("Please select a sale order!")
                   }
                }
                else if(this.stockcard.type == 'DO')
                {
                    isValid = true
                }
                else if(this.stockcard.type == 'GRN')
                {
                    if(this.stockcard.contact_id)
                    {
                        isValid = true
                    }
                }
                else if(this.stockcard.type == 'GRN_PO')
                {
                  if(this.stockcard.reference_id != '' && this.stockcard.reference_id != null)
                   {
                       await this.$store.dispatch("purchase/fetchPoItems", {document_id:this.stockcard.reference_id, warehouse_id:this.stockcard.warehouse_id, movement_date:this.stockcard.movement_date })
                       this.stockcard_items = this.po_items
                       isValid = true
                   }
                   else
                   {
                       alert("Please select a purchase order!")
                   }
                }


            }
            else
            {
                alert("Warehouse & Movement Date Required!")
            }
            return isValid;
        },
        deleteItem(index)
        {
            this.stockcard_items.splice(index, 1);
        },
        onComplete()
        {
            this.createStockCard()
        },
        getTotalLotQty(lots)
        {
            let sum = lots.reduce(function(sum, lot) {
                let updatedSum = sum + (lot.qty *1);
            return updatedSum;
            }, 0);


            return sum;
        },
        async addToDoItems()
        {
            let product_id = this.stockcard.product_id
            let has_lot = this.stockcard.has_lot
            let expiry_mths = this.stockcard.expiry_mths

            await this.$store.dispatch("stockcards/retrieveLots", 
            {
                product_id:product_id, 
                warehouse_id:this.stockcard.warehouse_id, 
                has_lot:has_lot, 
                expiry_mths:expiry_mths,
                movement_date:this.stockcard.movement_date
            })

            let qty = this.stockcard.allocate_qty * 1

            if(has_lot == '1' || expiry_mths)
            {
                if(this.lots.length > 0)
                {
                    let available_qty = 0;
                    for(let i = 0; i < this.lots.length; i++)
                    {
                        available_qty = available_qty + this.lots[i].qty;
                        if(this.lots[i].qty >= qty)
                        {
                            this.lots[i].allocate_qty =  qty
                        }
                        else
                        {
                            this.lots[i].allocate_qty = this.lots[i].qty
                        }

                        qty = qty - this.lots[i].allocate_qty
                    }
                
                    this.stockcard_items.push(
                    {
                        is_collapsed:false,
                        lots:this.lots,
                        warehouse_id:this.stockcard.warehouse_id,
                        product_id:this.stockcard.product_id,
                        product_code:this.stockcard.product_code,
                        product_name:this.stockcard.product_name,
                        location_id:this.stockcard.location_id,
                        location_code:this.stockcard.location_code,
                        location_name:this.stockcard.location_name,
                        allocate_qty:this.stockcard.allocate_qty,
                        available_qty:available_qty,
                        lot_reference:this.stockcard.lot_reference,
                        expiry_date:this.stockcard.expiry_date,
                        remarks:this.stockcard.item_remarks
                    })
                }
                else
                {
                    alert("Invalid Qty")
                }
            }
            else
            {
                // Product Without lots or without expiry
                let available_qty = 0;
                for(let i = 0; i < this.lots.length; i++)
                {
                    available_qty = available_qty + this.lots[i].qty
                    if(this.lots[i].qty >= qty)
                    {
                        this.lots[i].allocate_qty =  qty
                    }
                    else
                    {
                        this.lots[i].allocate_qty = this.lots[i].qty
                    }

                    qty = qty - this.lots[i].allocate_qty
                }
                
                this.stockcard_items.push(
                {
                    is_collapsed:false,
                    lots:this.lots,
                    warehouse_id:this.stockcard.warehouse_id,
                    product_id:this.stockcard.product_id,
                    product_code:this.stockcard.product_code,
                    product_name:this.stockcard.product_name,
                    location_id:this.stockcard.location_id,
                    location_code:this.stockcard.location_code,
                    location_name:this.stockcard.location_name,
                    allocate_qty:this.stockcard.allocate_qty,
                    lot_reference:this.stockcard.lot_reference,
                    expiry_date:this.stockcard.expiry_date,
                    remarks:this.stockcard.item_remarks,
                    available_qty:available_qty,
                })

                this.stockcard.location = {}
                this.stockcard.location_id = '';
                this.stockcard.location_code = '';
                this.stockcard.location_name= '';

                this.stockcard.product_code = '';
                this.stockcard.product_id = '';
                this.stockcard.product_name = "",
                this.stockcard.has_lot = 0;
                this.stockcard.expiry_date = null,
                this.stockcard.allocate_qty = '',
                this.stockcard.expiry_mths = ""
                this.stockcard.trade_item = {}
            }
     
        },
        clickOnAdd()
        {
            if(this.stockcard.allocate_qty == '' || this.stockcard.allocate_qty == null || this.stockcard.allocate_qty ==  0 || this.stockcard.location_id == '')
            {
                alert("Location / Qty Required")
            }
            else
            {
                if(this.stockcard.product_name == '' )
                {
                    alert("Product Name Required!")
                }
                else
                {
                    if(this.direction == 'IN' && (this.stockcard.type == 'ADJUSTMENT' || this.stockcard.type == 'GRN') )
                    {
                        this.addToList()
                    }
                    else
                    {
                        if(this.direction == 'OUT' && this.stockcard.type == 'ADJUSTMENT')
                        {

                            if(this.stockcard.location_id && this.stockcard.product_id && this.stockcard.allocate_qty)
                            {
                                // 
                                
                                this.stockcard.available_qty = this.stockcard.available_qty*1;
                                this.stockcard.allocate_qty = this.stockcard.allocate_qty *1;

                                if(this.stockcard.available_qty >= this.stockcard.allocate_qty)
                                {
                                    this.addToDoItems()
                                }
                                else
                                {
                                    alert("Invalid QTY")
                                }
                            }
                            else
                            {
                                alert("Product / Location / Qty Required!")
                            }
                        }
                        else
                        {
                            this.addToDoItems()
                        }
                    }
                }

            }
        },
        isFoundInList(name)
        {
            let is_found = 0
            for(let i = 0; i < this.desp_tags.length; i++)
            {
                if(this.desp_tags[i].product_name == name)
                {
                is_found = 1
                }
            }
            return is_found;
        },
        addToList()
        {
            this.stockcard_items.push(
            {
                is_collapsed:false,
                lots:[],
                warehouse_id:this.stockcard.warehouse_id,
                product_id:this.stockcard.product_id,
                product_code:this.stockcard.product_code,
                product_name:this.stockcard.product_name,
                location_id:this.stockcard.location_id,
                location_code:this.stockcard.location_code,
                location_name:this.stockcard.location_name,
                allocate_qty:this.stockcard.allocate_qty,
                lot_reference:this.stockcard.lot_reference,
                expiry_date:this.stockcard.expiry_date,
                remarks:this.stockcard.item_remarks
            })

            this.stockcard.location = {}
            this.stockcard.location_id = '';
            this.stockcard.location_code = '';
            this.stockcard.location_name= '';

            this.stockcard.product_code = '';
            this.stockcard.product_id = '';
            this.stockcard.product_name = "",
            this.stockcard.has_lot = 0;
            this.stockcard.expiry_date = null,
            this.stockcard.allocate_qty = '',
            this.stockcard.expiry_mths = ""
            this.stockcard.trade_item = {}
        },
        selectLocation(obj)
        {
            
            if(obj)
            {
                this.stockcard.location_id = obj.id
                this.stockcard.location_code = obj.code
                this.stockcard.location_name = obj.name
            }
        },
        async selectProduct(obj)
        {
            if(obj)
            {
                this.stockcard.expiry_date = null
                this.stockcard.product_id = obj.id
                this.stockcard.product_code = obj.code
                this.stockcard.product_name = obj.name
                this.stockcard.has_lot = obj.has_lot
                this.stockcard.expiry_mths = obj.expiry_mths
                this.stockcard.is_trade = obj.is_trade


                if(this.stockcard.is_trade == '1')
                {
                    this.stockcard.product_name = ''
                }

                if(this.stockcard.movement_date && this.stockcard.expiry_mths)
                {
                    this.stockcard.expiry_date = moment(this.stockcard.movement_date).add(this.stockcard.expiry_mths, "months").format("YYYY-MM-DD");
                }

                await this.asyncFindLocation()
            }
        },
        async confirmCreateStockCard()
        {
            let payload = {
                        warehouse_id:this.stockcard.warehouse_id, 
                        reference_id:this.stockcard.reference_id,
                        remarks:this.stockcard.remarks,
                        movement_date:this.stockcard.movement_date, 
                        items:this.stockcard_items, 
                        direction:this.direction,
                        type:this.stockcard.type,
                        contact_id:this.stockcard.contact_id,
                        is_confirmed:1
            }
            await this.$store.dispatch("stockcards/create", payload)
        },
        async createStockCard()
        {
            if((this.stockcard.type == 'DO_SO' || this.stockcard.type == 'DO' || this.stockcard.type == 'GRN_PO') && this.is_confirmed == 0 )
            {
                let payload = {
                                warehouse_id:this.stockcard.warehouse_id, 
                                reference_id:this.stockcard.reference_id,
                                remarks:this.stockcard.remarks,
                                movement_date:this.stockcard.movement_date, 
                                items:this.stockcard_items, 
                                direction:this.direction,
                                type:this.stockcard.type,
                                contact_id:this.stockcard.contact_id,
                                is_confirmed:0
                           }
                await this.$store.dispatch("stockcards/create", payload)

                if(this.is_confirmation_required == 1)
                {
                    let messages = this.confirmation_messages
                    let msg = '';
                    if (Array.isArray(messages)) {
                        msg = messages.join("\n")
                    }
                    let response = await this.$confirm(msg, this.language_terms['CONFIRMATION'], {
                        confirmButtonText: this.language_terms['CONFIRM'],
                        cancelButtonText: this.language_terms['CANCEL'],
                        type: 'warning'
                        }).catch(() => 
                        {
                            this.$message.info(this.language_terms['ACTION_CANCEL'])
                        })
                        if (response === 'confirm') 
                        {
                            this.loading = true
                            await this.confirmCreateStockCard()
                            this.loading = false
                        }
                }
            }
            else
            {
                await this.confirmCreateStockCard()
            }

            if(this.is_stockcard_created == 1)
            {
                this.$router.push("/inventory/stockcards")
            }
        }
    }
}

</script>
